import { makeStyles } from 'tss-react/mui'
import { primary, red } from '../../assets/colors'

export const useStyles = makeStyles()((theme) => {
    const numFeatures = "'tnum' on, 'lnum' on"

    return {
        table: {
            tableLayout: 'fixed',
            width: '100%',
            border: 0,
        },
        side: {
            flex: 1,
            minWidth: 0,
        },
        tableRow: {
            border: 'none',
            '& > td': {
                height: 22,
                boxSizing: 'border-box',
                verticalAlign: 'middle',
            },
        },
        headerCell: {
            padding: '2px 4px',
            color: theme.palette.text.disabled,
            textAlign: 'right',
            border: 0,
            '&:first-of-type': {
                textAlign: 'left',
                width: '34%',
            },
            '&:nth-of-type(2)': {
                width: '26%',
            },
            '&:nth-of-type(3)': {
                width: '40%',
            },
        },
        rowCell: {
            padding: '2px 4px',
            textAlign: 'right',
            fontSize: '13px',
            lineHeight: 1.2,
            border: 0,
            fontFeatureSettings: numFeatures,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            '&:first-of-type': {
                textAlign: 'left',
            },
        },
        qtyCell: {
            textAlign: 'right',
        },
        qtyValue: {
            display: 'block',
            height: '100%',
            paddingLeft: 8,
            textAlign: 'right',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        },
        bidCell: {
            color: primary,
        },
        askCell: {
            color: red,
        },
        totalRowCell: {
            padding: '2px 4px',
            border: 0,
            fontSize: '13px',
            lineHeight: 1.2,
            fontFeatureSettings: numFeatures,
        },
        totalRowContent: {
            display: 'flex',
            alignItems: 'baseline',
            justifyContent: 'space-between',
            gap: theme.spacing(1),
            minWidth: 0,
            width: '100%',
        },
        totalLabel: {
            color: theme.palette.text.secondary,
            flexShrink: 0,
        },
        totalValues: {
            display: 'flex',
            alignItems: 'baseline',
            justifyContent: 'flex-end',
            gap: theme.spacing(0.75),
            minWidth: 0,
            flex: 1,
            textAlign: 'right',
        },
        totalPct: {
            color: theme.palette.text.secondary,
            fontSize: '11px',
            lineHeight: 1.2,
            flexShrink: 0,
        },
        totalQty: {
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            textAlign: 'right',
        },
        tradeable: {
            cursor: 'pointer',
            '&: hover td': {
                color: 'unset',
            },
        },
    }
})
